var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88994 1.16663H5.10994C2.91661 1.16663 2.74744 3.13829 3.93161 4.21163L10.0683 9.78829C11.2524 10.8616 11.0833 12.8333 8.88994 12.8333H5.10994C2.91661 12.8333 2.74744 10.8616 3.93161 9.78829L10.0683 4.21163C11.2524 3.13829 11.0833 1.16663 8.88994 1.16663Z",
    stroke: "#EF4747",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.acb4961cd2ec1cf1d8e1515a48ebb59c.svg";
export { ForwardRef as ReactComponent };